import useFetch from "react-fetch-hook";
import { processResponse } from "../Navigation/navigation.functions";

import ConstellationHeader from "./ConstellationHeader";

interface HeaderProps {
  /**
    Urls to fetch data and execute login logout and register actions
  */
  urls: {
    navLinks: string; // url to get the structure of links for the main navigation
  };
}

export default function ConstellationHeaderWithAPI({ urls }: HeaderProps) {
  const { data: navLinks } = useFetch(urls.navLinks);
  const defaultNavItems = [
    {
      id: "1",
      shouldOpenInNewWindow: false,
      label: "ABOUT US",
      link: `/`,
      isVisible: true,
    },
    {
      id: "2",
      shouldOpenInNewWindow: false,
      label: "OUR BRANDS",
      link: "/",
      isVisible: true,
    },
    {
      id: "3",
      shouldOpenInNewWindow: false,
      label: "STAKEHOLDER",
      link: "/",
      isVisible: true,
    },
    {
      id: "4",
      shouldOpenInNewWindow: false,
      label: "CONTACT",
      link: "https://www.bca-online-auctions.co.uk/login.html",
      isVisible: true,
    },
  ];

  const processedNavLinks = processResponse(navLinks);

  return (
    <ConstellationHeader
      navItems={
        processedNavLinks.length > 0 ? processedNavLinks : defaultNavItems
      }
    ></ConstellationHeader>
  );
}
